// Ported from design/project/App73-RejoinChannel.dc.html, then wired: shown when a player who left the channel
// tries to battle. Money is never affected; the wallet stays one tap away.
import { useChannelJoin } from "../channel.js";
import { useGame } from "../game.js";

export function App73_RejoinChannel() {
  const { open } = useChannelJoin();
  const { me } = useGame();
  return (
    <>
      <div className="screen">
  <div className="orbR" aria-hidden="true" style={{ top: "40px", right: "-45px", width: "480px", height: "480px" }}></div>
  <div className="pad squeeze" style={{ height: "100%", paddingBottom: "44px" }}>
    <div className="top"><span className="chip chipR">BATTLES PAUSED</span></div>
    <div style={{ marginTop: "14px", display: "flex", justifyContent: "center" }}><div style={{ width: "88px", height: "88px", borderRadius: "28px", background: "rgba(255,51,102,0.1)", border: "1px solid rgba(255,51,102,0.45)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 50px rgba(255,51,102,0.25)" }}><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#FF3366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 3 L3 10.5 L10 13 L13 20 Z"></path><path d="M10 13 L21 3"></path><path d="M3 3 L21 21"></path></svg></div></div>
    <h1 className="h1" style={{ marginTop: "22px", textAlign: "center" }}>You left the squad</h1>
    <p className="muted" style={{ margin: "8px 6px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px" }}>Rejoin @degensduel to queue for battles again. It takes one tap.</p>

    <div style={{ marginTop: "20px", padding: "18px", borderRadius: "20px", background: "linear-gradient(160deg, rgba(204,255,0,0.1), rgba(22,27,34,0.9) 60%)", border: "1px solid rgba(204,255,0,0.35)", display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
      <span className="lbl">BATTLE BALANCE</span>
      <span className="mono" style={{ fontWeight: "800", fontSize: "36px", lineHeight: "42px" }}>{me?.balance.available ?? "--"} <span style={{ fontSize: "16px" }} className="muted">USDT</span></span>
      <span className="lime" style={{ fontSize: "12px", fontWeight: "600" }}>Safe, and you can withdraw it anytime</span>
    </div>

    <div className="g" style={{ marginTop: "12px", borderRadius: "18px", padding: "4px 0" }}>
      <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Battles and challenges</span><span className="red" style={{ fontSize: "13px", fontWeight: "600" }}>Paused</span></div>
      <div className="div" style={{ margin: "0 14px" }}></div>
      <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Deposits and withdrawals</span><span className="lime" style={{ fontSize: "13px", fontWeight: "600" }}>Working</span></div>
    </div>

    <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: "10px" }}>
      <button className="btnP" onClick={open}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0B0E14" strokeWidth="2.4" strokeLinejoin="round" aria-hidden="true"><path d="M21 3 L3 10.5 L10 13 L13 20 Z"></path><path d="M10 13 L21 3"></path></svg>
        REJOIN @DEGENSDUEL</button>
      <a href="#/App28" className="btnS">Go to wallet</a>
    </div>
  </div>
</div>
    </>
  );
}
